import { defineStore } from "pinia";
import Services from '@/services/jobRecordServices'
import { mapJobRecord } from '@/helpers/mapFuncs'

export const useJobRecordStore = defineStore("jobRecord", {

state:()=>({
    jobRecord: {},
    jobRecords: [],
}),
getters : {
    getJobRecord() {
        return mapJobRecord(this.jobRecord)
    },
    getJobRecords() {
        return this.jobRecords.map(mapJobRecord)
    }
},
actions : {
    /** Start Sets */
    setJobRecord(jobRecord) {
        this.jobRecord = jobRecord
    },
    setJobRecords(jobRecords) {
        this.jobRecords = jobRecords
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setJobRecord(response.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setJobRecord(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setJobRecords(response.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.jobRecords.push(response.data)
            return mapJobRecord(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.jobRecords[this.jobRecords.findIndex((x)=>x.id == id)] = response.data
            return mapJobRecord(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.jobRecords = this.jobRecords.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});